import { EsaSessionType, useSession } from "@outschool/ui-auth";
import { useLocation } from "react-router-dom";

import * as User from "../../../../shared/User";
import { isOrganizationAdminWhoCanEnroll } from "../../../lib/Users";
import { PrepayType } from "../../../routes/EnrollmentMeetingPurchasePage";
import { useMembershipRequirement } from "../../subscriptions/hooks/useMembershipRequirement";

export default function useTutoringFlow() {
  const { currentUser, isLoggedIn, esaSessionType } = useSession();
  const { mustPurchaseMembership } = useMembershipRequirement();
  const location = useLocation();

  const isClassWalletSession = esaSessionType === EsaSessionType.CW;
  const isPrepayMeetings =
    location.query?.isPrepayMeetings === "true"
      ? true
      : location.query?.isPrepayMeetings === "false"
      ? false
      : undefined;

  const prepayType = isOrganizationAdminWhoCanEnroll(currentUser)
    ? PrepayType.CharterAdmin
    : isPrepayMeetings === true && !!User.isAdmin(currentUser)
    ? PrepayType.CharterPO
    : isClassWalletSession
    ? PrepayType.ClassWallet
    : null;

  // NOTE: There are 2 different flows for tutoring:
  // 1. Inline available times
  // 2. Modal that shows the available times
  const tutoringShowAvailableTimesInline =
    prepayType === PrepayType.CharterAdmin ||
    prepayType === PrepayType.CharterPO ||
    prepayType === PrepayType.ClassWallet ||
    // For these users, show the inline version so that they can see available times before buying a membership.
    mustPurchaseMembership ||
    !isLoggedIn;

  return { tutoringShowAvailableTimesInline };
}
